import { useQuery } from "@apollo/client";
import { useCompanyPageStore } from "../../../../../../store/companyPageStore";
import {
  COMPANY_INSTALL_TOP_VENDORS_BY_PRODUCTS_QUERY,
  TopVendorsByProductsCountPayload,
} from "../../../../../../legacy/queries/Installs";
import { COMPANY_SEARCH_CLIENT } from "../../../../../../utils/consts";

interface Props {
  hgId: string;
  skip?: boolean;
}

export const useTopVendorsByProducts = (props: Props) => {
  const installFilters = useCompanyPageStore((state) => state.installFilters);
  const { data, loading: isLoading } =
    useQuery<TopVendorsByProductsCountPayload>(
      COMPANY_INSTALL_TOP_VENDORS_BY_PRODUCTS_QUERY,
      {
        context: { clientName: COMPANY_SEARCH_CLIENT },
        variables: {
          hgId: props.hgId,
          vendorIds: installFilters.vendorIds,
          productIds: installFilters.productIds,
          countryAlpha2s: installFilters.countryAlpha2s,
          productCategoryIds: installFilters.productCategoryIds,
        },
        skip: props.skip,
      }
    );

  return {
    data,
    isLoading,
  };
};
